import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "../pages/Footer";
import { useDispatch } from "react-redux";
import { addToCart } from "../Redux/cart/cartSlice";

const ProductDetails = ({ product }) => {
  
  const [mainImage, setMainImage] = useState(product.images[0]);
  const dispatch = useDispatch();
  const handleAddToCart = (product)=>{
    dispatch(addToCart(product))
  }

  return (
    <div className="flex flex-col md:flex-row p-6 gap-6 max-w-6xl mx-auto my-7 bg-white shadow-lg rounded-lg">
      {/* Left Side - Images */}
      <div className="flex flex-col items-center w-full md:w-1/2 h-[530px]">
        <img src={mainImage} alt={product.name} className="w-full h-[80%] object-contain object-center rounded-lg" />
        <div className="flex gap-3 mt-3">
          {product.images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Thumbnail ${index}`}
              className="w-24 h-24 object-cover rounded-lg cursor-pointer border-2 border-transparent hover:border-gray-500"
              onClick={() => setMainImage(img)}
            />
          ))}
        </div>
      </div>

      {/* Right Side - Product Details */}
      <div className="w-full md:w-1/2 flex flex-col justify-between">
        <h1 className="text-3xl font-semibold text-gray-800">{product.name}</h1>
        <p className="text-gray-600 mt-2">{product.description}</p>
        <p className="text-gray-700 mt-2 font-medium">Brand: {product.brand}</p>
        <p className="text-gray-700 mt-2 font-medium">Material: {product.material}</p>
        <p className="text-gray-700 mt-2 font-medium">Color Options: {product.colorOptions.join(", ")}</p>
        <p className="text-gray-700 mt-2 font-medium">Dimensions: {product.dimensions.height} x {product.dimensions.width} x {product.dimensions.depth}</p>
        <p className="text-gray-700 mt-2 font-medium">Weight: {product.weight}</p>
        <p className="text-green-600 text-xl font-bold mt-4">${product.finalPrice} <span className="text-gray-500 line-through">${product.price}</span></p>
        <p className="text-gray-700 mt-2">Discount: {product.discount}%</p>
        <p className="text-gray-700 mt-2">Ratings: {product.ratings} ⭐ ({product.reviewsCount} reviews)</p>
        <p className="text-gray-700 mt-2">Stock: {product.stock > 0 ? `${product.stock} Available` : "Out of Stock"}</p>
        <p className="text-gray-700 mt-2">Warranty: {product.warranty}</p>
        <p className="text-gray-700 mt-2">Return Policy: {product.returnPolicy}</p>
        <button className="mt-5 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition" onClick={()=>handleAddToCart(product)}>Add to Cart</button>
      </div>
    </div>
  );
};



const ProductPage = () => {
  const location = useLocation();
  const product = location.state?.product
  return (
    <div>
      <Navbar/>
      <ProductDetails product={product} />
      <Footer/>
    </div>
  );
};

export default ProductPage;
